import * as firebase from 'firebase/app';

if (process.env.REACT_APP_FIREBASE_CONFIG) {
    firebase.initializeApp(JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG));
} else {
    console.log('Error initializing firebase - config env variable not found!');
}
